<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/ZOOM_ROOMS/mixin';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';
import { PLAN_TYPES_WITH_MULTI_BASE_PLANS } from '@/plans/ROOM_CONNECTOR/common/utils';
import { pageConfig } from '@/common/service/page-config';

export default {
  mixins: [mixin, commonMixin],
  name: 'ZoomRoomCart',
  computed: {
    showRemove() {
      const { from: currentPrimaryPlan } = pageConfig;
      // Some plan may has more than 1 base plan dependencies like CRC
      const hasThePlanNeedsMultiBasePlan = PLAN_TYPES_WITH_MULTI_BASE_PLANS.includes(currentPrimaryPlan);
      if(hasThePlanNeedsMultiBasePlan) {
        return !this.mx_isLastBasePlanForTheSameBillingCycle
      }
      return !this.mx_isLastBasePlan
    }
  },
  methods: {
    mx_license(num) {
      return (
        <div class="opc-cart-item__text">
          {num} {getPlanUnitWithQuantity(planUnitMap.room)}
        </div>
      );
    },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, this.mx_price(plan))}
                {this.mx_license(plan.cartInfo.selected_number)}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                {this.mx_edit(plan)}
                {this.showRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
